export const setRulesItem = () => {
    localStorage.setItem("acceptRules4" , true)
}

export const checkAcceptRules = () => {
    const acceptRules = localStorage.getItem("acceptRules4");

    if(acceptRules) return true

    return false
}